<template v-if="isShowProductTitle">
  <div :class="['p-title', titleClass]" >
    <a target="_blank" :href="product.link">
      <h3 :style="[titleStyles]">{{product.title}}</h3>
    </a>
  </div>
</template>
      
<script>
export default {
  name: "ProductTitle",
  props: ["product"],
  computed: {
    // title
    isShowProductTitle: function() {
      return this.$store.state.front.settings.titleDisplay;
    },
    titleStyles: function() {
      return {
        color: this.$store.state.front.settings.titleColor,
        fontSize: this.$store.state.front.settings.titleFontsize + "px"
      };
    },
    titleClass: function() {
      return this.$store.state.front.settings.titleClass;
    }
  }
};
</script>

<style lang="scss" scoped>
.p-title {
  font-size: 14px;
  font-weight: bold;
  h3 {
    font-size: 14px;
    font-weight: bold;
    margin: auto;
    padding: 0;
  }
  a {
    text-decoration: none !important;
  }
}
</style>